import React from 'react';

function ArrowIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 20C8.7 20 8.5 19.9006 8.3 19.7019C7.9 19.3043 7.9 18.7081 8.3 18.3106L14.6 11.9503L8.3 5.68944C7.9 5.29193 7.9 4.69565 8.3 4.29814C8.7 3.90062 9.3 3.90062 9.7 4.29814L16.7 11.2547C16.9 11.4534 17 11.6522 17 11.9503C17 12.2484 16.9 12.4472 16.8 12.646L9.8 19.6025C9.5 19.9006 9.3 20 9 20Z"
        fill="#FF8A00"
      />
    </svg>
  );
}

export default ArrowIcon;
